import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                id: null,
                title: '',
                uuid: null,
                groups: [],
                tags: [],
                created_at: null,
                updated_at: null,
                archived_at: null,
            };
        },

        getters: {},

        actions: {
            edit(context, { field, value }) {
                context.commit('EDIT_FIELD', { field, value });
            },
        },

        mutations: {
            EDIT_FIELD(state, { field, value }) {
                state[field] = value;
            },
        },
    }
);
